// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_keychain_loop/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_keychain_loop: ModuleSchema = {
  "id": "core_keychain_loop",
  "uniqueId": "B3D_LOOP1",
  "createdAt": "2026-10-02T02:50:00Z",
  "updatedAt": "2026-10-28T14:58:32.265Z",
  "label": "Keychain Loop",
  "description": "Standalone core geometry module for parametric keychain attachment loop and keyring ear (CG_LOOP01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_LOOP01",
    "keychain-loop",
    "keyring-ear"
  ],
  "sliders": [
    {
      "key": "displayMode",
      "label": "Display Mode (0:Loop+Host, 1:Loop Only)",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "outerD",
      "label": "Outer Diameter (mm)",
      "min": 6,
      "max": 18,
      "default": 10,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "innerD",
      "label": "Inner Hole Diameter (mm)",
      "min": 3,
      "max": 10,
      "default": 5,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "thickness",
      "label": "Lug Thickness (mm)",
      "min": 1.5,
      "max": 6,
      "default": 3,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "wallClearance",
      "label": "Wall Clearance (mm)",
      "min": 0.5,
      "max": 3,
      "default": 1,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "bridgeOverlap",
      "label": "Bridge Overlap (mm)",
      "min": 1,
      "max": 4,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "bridgeEnabled",
      "label": "Bridge (0: Off, 1: On)",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "bridgeWidth",
      "label": "Bridge Width (mm; used when enabled)",
      "min": 2,
      "max": 15,
      "default": 4,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "host_body",
      "label": "Host Wall / Body",
      "default": "#64748B",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keychain_loop",
      "label": "Attachment Loop Solid",
      "default": "#3B82F6",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_host",
      "label": "Host Wall Assembly",
      "name": "Host Wall Assembly",
      "color": "#64748B",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "host_body",
          "label": "Host Wall / Body",
          "name": "Host Wall / Body",
          "groupId": 1,
          "colorKey": "host_body",
          "defaultColor": "#64748B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_loop",
      "label": "Keychain Loop Assembly",
      "name": "Keychain Loop Assembly",
      "color": "#3B82F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "keychain_loop",
          "label": "Attachment Loop Solid",
          "name": "Attachment Loop Solid",
          "groupId": 0,
          "colorKey": "keychain_loop",
          "defaultColor": "#3B82F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Keychain Loop"
    },
    {
      "id": "1",
      "label": "Download STL - Host Wall"
    }
  ]
};
